export default "__VITE_ASSET__DdG0nXgU__"